import { Link } from 'react-router-dom';
import { MdLockOutline, MdSupportAgent, MdCreditCard } from 'react-icons/md';
import { SUPPORT_EMAIL } from '../../config/support';

// Shown in place of a data table when the API returns CLUB_SUSPENDED /
// SUBSCRIPTION_EXPIRED / CLUB_CANCELLED, so admins see *why* access is blocked
// instead of a misleading "0 records" empty state.
export default function SuspendedAccessPanel({ cancelled = false }) {
  return (
    <div className="flex flex-col items-center justify-center text-center px-6 py-16 bg-card border border-divider rounded-2xl">
      <div className="w-14 h-14 rounded-2xl bg-red-500/15 flex items-center justify-center mb-4">
        <MdLockOutline className="text-3xl text-red-400" />
      </div>
      <h2 className="text-lg font-bold text-secondary">
        {cancelled ? 'Account access ended' : 'Club subscription suspended'}
      </h2>
      <p className="text-sm text-muted mt-2 max-w-md leading-relaxed">
        {cancelled
          ? 'This club account is no longer active. Please contact TrainAxis support to restore access.'
          : 'Your subscription is suspended. Please contact TrainAxis support or complete payment to restore access.'}
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
        {!cancelled && (
          <Link
            to="/admin/subscription"
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-primary text-white text-sm font-semibold hover:bg-primary-dark transition-colors"
          >
            <MdCreditCard className="text-base" />
            Submit Payment
          </Link>
        )}
        <a
          href="https://wa.me/61414934174"
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-primary text-white text-sm font-semibold hover:bg-primary-dark transition-colors"
        >
          <MdSupportAgent className="text-base" />
          WhatsApp Us
        </a>
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl border border-divider text-secondary text-sm font-semibold hover:bg-nav-hover transition-colors"
        >
          Email Support
        </a>
      </div>
    </div>
  );
}
